<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form id="FormTipolente" role="form" method="post" autocomplete="off" onSubmit="return false">
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Nombre">Nombre</label>
							<input type="text" v-model="objTipolente.Nombre" class="form-control" id="Nombre" placeholder="Ingresar Nombre" />
							<CValidation v-if="this.errorvalidacion.Nombre" :Mensaje="'*'+errorvalidacion.Nombre[0]"/>
						</div>
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Clave">Clave</label>
							<input type="text" v-model="objTipolente.Clave" class="form-control" id="Clave" placeholder="Ingresar Clave" />
							<CValidation v-if="this.errorvalidacion.Clave" :Mensaje="'*'+errorvalidacion.Clave[0]"/>
						</div>
					</div>
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="Proceso">Proceso</label>
							<select name="Proceso" id="Proceso" v-model="objTipolente.Proceso" class="form-control form-select">
								<option value="">Seleccione una opción</option>
								<option v-for="(item, index) in Procesos" :value="item.Num" :key="index">{{item.Num}} - {{item.Desc}}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.Proceso" :Mensaje="'*'+errorvalidacion.Proceso[0]"/>
						</div>
					</div>
					<div class="form-group row">
						<h6>Requiere en RX:</h6>
                        <!--<div v-show="false" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex align-items-center">
                                <div class="form-check">
									<input type="checkbox" v-model="objTipolente.Esfera" class="form-check-input" id="Esfera" />
								</div>
								<label class="form-label mb-0" for="Esfera">Esfera</label>
							</div>
							<CValidation v-if="this.errorvalidacion.Esfera" :Mensaje="'*'+errorvalidacion.Esfera[0]"/>
						</div>			
                        <div v-show="false" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex align-items-center">
                                <div class="form-check">
									<input type="checkbox" v-model="objTipolente.Cilindro" class="form-check-input" id="Cilindro" />
								</div>
								<label class="form-label mb-0" for="Cilindro">Cilindro</label>
							</div>
							<CValidation v-if="this.errorvalidacion.Cilindro" :Mensaje="'*'+errorvalidacion.Cilindro[0]"/>
						</div>	

                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex align-items-center">
                                <div class="form-check">
									<input type="checkbox" v-model="objTipolente.Eje" class="form-check-input" id="Eje" />
								</div>
								<label class="form-label mb-0" for="Eje">Eje</label>
							</div>
							<CValidation v-if="this.errorvalidacion.Eje" :Mensaje="'*'+errorvalidacion.Eje[0]"/>
						</div>-->

						
						<div class="col-12 col-sm-6 col-md-4 col-lg-4">
                            <div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="objTipolente.Adicion" class="form-check-input" role="switch" type="checkbox" id="Adicion">
                                <label class="form-check-label" for="Adicion">Adición</label>
                            </div>
							<CValidation v-if="this.errorvalidacion.Adicion" :Mensaje="'*'+errorvalidacion.Adicion[0]"/>
                        </div>


						<div class="col-12 col-sm-6 col-md-4 col-lg-4">
                            
                        </div>

                        									
                         <!-- <div v-show="false" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex align-items-center">
                                <div class="form-check">
									<input type="checkbox" v-model="objTipolente.Dnp" class="form-check-input" id="Dnp" />
								</div>
								<label class="form-label mb-0" for="Dnp">Dnp</label>
							</div>
							<CValidation v-if="this.errorvalidacion.Dnp" :Mensaje="'*'+errorvalidacion.Dnp[0]"/>
						</div>					
                         <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex align-items-center">
                                <div class="form-check">
									<input type="checkbox" v-model="objTipolente.Prisma" class="form-check-input" id="Prisma" />
								</div>
								<label class="form-label mb-0" for="Prisma">Prisma</label>
							</div>
							<CValidation v-if="this.errorvalidacion.Prisma" :Mensaje="'*'+errorvalidacion.Prisma[0]"/>
						</div>					
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="d-flex align-items-center">
                                <div class="form-check">
									<input type="checkbox" v-model="objTipolente.Posicion" class="form-check-input" id="Posicion" />
								</div>
								<label class="form-label mb-0" for="Posicion">Posición</label>
							</div>
							<CValidation v-if="this.errorvalidacion.Posicion" :Mensaje="'*'+errorvalidacion.Posicion[0]"/>
						</div> -->					
					</div>
					
					<div class="form-group row mt-3">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="fs-6">Rango Altura Montaje</label>
						</div>
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="objTipolente.AltMon" @change="cleanMontaje()" class="form-check-input" role="switch" type="checkbox" id="AltMon">
                                <label class="form-check-label" for="AltMon">Alt. Mont.</label>
                            </div>
							<CValidation v-if="this.errorvalidacion.AltMon" :Mensaje="'*'+errorvalidacion.AltMon[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" v-if="objTipolente.AltMon">
							<label class="form-label" for="ValMinMon">Valor mínimo</label>
							<input type="text" @input="$onlyNums($event,objTipolente,'ValMinMon')" v-model="objTipolente.ValMinMon" class="form-control" id="ValMinMon" placeholder="Ingresar valor mínimo" />
							<CValidation v-if="this.errorvalidacion.ValMinMon" :Mensaje="'*'+errorvalidacion.ValMinMon[0]"/>
						</div>
					
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6" v-if="objTipolente.AltMon">
							<label class="form-label" for="ValMaxMon">Valor máximo</label>
							<input type="text" @input="$onlyNums($event,objTipolente,'ValMaxMon')" v-model="objTipolente.ValMaxMon" class="form-control" id="ValMaxMon" placeholder="Ingresar valor máximo" />
							<CValidation v-if="this.errorvalidacion.ValMaxMon" :Mensaje="'*'+errorvalidacion.ValMaxMon[0]"/>
						</div>
					</div>
					
					<div class="form-group row mt-4">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="fs-6">Rango Altura Segmento</label>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div class="form-check-inline form-check form-switch form-sw">
                                <input v-model="objTipolente.AltSeg" @change="cleanSegmento()" class="form-check-input" role="switch" type="checkbox" id="AltSeg">
                                <label class="form-check-label" for="AltSeg">Requiere Altura de Segmento</label>
                            </div>
							<CValidation v-if="this.errorvalidacion.AltSeg" :Mensaje="'*'+errorvalidacion.AltSeg[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4" v-if="objTipolente.AltSeg">
							<label class="form-label" for="ValMinSeg">Valor mínimo</label>
							<input type="text" @input="$onlyNums($event,objTipolente,'ValMinSeg')" v-model="objTipolente.ValMinSeg" class="form-control" id="ValMinSeg" placeholder="Ingresar valor mínimo" />
							<CValidation v-if="this.errorvalidacion.ValMinSeg" :Mensaje="'*'+errorvalidacion.ValMinSeg[0]"/>
						</div>
						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4" v-if="objTipolente.AltSeg">
							<label class="form-label" for="ValMaxSeg">Valor máximo</label>
							<input type="text" @input="$onlyNums($event,objTipolente,'ValMaxSeg')" v-model="objTipolente.ValMaxSeg" class="form-control" id="ValMaxSeg" placeholder="Ingresar valor máximo" />
							<CValidation v-if="this.errorvalidacion.ValMaxSeg" :Mensaje="'*'+errorvalidacion.ValMaxSeg[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-4 col-xl-4" v-if="objTipolente.AltSeg">
							<label class="form-label" for="ValDefaultAltSeg">Valor Default</label>
							<input type="text" @input="$onlyNums($event,objTipolente,'ValDefaultAltSeg')" v-model="objTipolente.ValDefaultAltSeg" class="form-control" id="ValDefaultAltSeg" placeholder="Ingresar valor máximo" />
							<CValidation v-if="this.errorvalidacion.ValDefaultAltSeg" :Mensaje="'*'+errorvalidacion.ValDefaultAltSeg[0]"/>
						</div>
					</div>
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormTipolente',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objTipolente: {
				IdTipoLente: 0,
				Nombre: '',
				Clave: '',
				Proceso: '',
				Esfera: false,
				Cilindro: false,
				Eje: false,
				Adicion: false,
				AltMon: false,
				AltSeg: false,
				Dnp: false,
				Prisma: false,
				Posicion: false,
				ValMinMon: '',
				ValMaxMon: '',
				ValMinSeg: '',
				ValMaxSeg: '',
				ValDefaultAltSeg: '',
				
            },
			Procesos:[
				{
					Num:1,
					Desc:'Tipo de Lente -> LINEAS -> Materiales -> proteccion -> Recubrimiento ->',
				},
				{
					Num:2,
					Desc:'Tipo de Lente -> LINEAS -> Recubrimiento -> Piezas',
				},
				{
					Num:3,
					Desc:'Tipo de Lente -> LINEAS -> Paquetes',
				},
			],
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			//masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			let objCopy = {...this.objTipolente};
			if(this.objTipolente.IdTipoLente == 0) {
				await this.$http.post(
					'tiposlentes',this.objTipolente
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'tiposlentes/'+this.objTipolente.IdTipoLente,
					this.objTipolente
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "tiposlentes/"+this.objTipolente.IdTipoLente
            ).then((res) => {
				let resp = res.data.data;
                this.objTipolente = resp;
				this.objTipolente.Esfera 	= resp.Esfera 	== 'SI' ? true : false;
				this.objTipolente.Cilindro 	= resp.Cilindro == 'SI' ? true : false;
				this.objTipolente.Eje 		= resp.Eje 		== 'SI' ? true : false;
				this.objTipolente.Adicion 	= resp.Adicion 	== 'SI' ? true : false; // Ajuste de inversion 15/03/2025
				this.objTipolente.AltMon 	= resp.AltMon 	== 'SI' ? true : false; // Ajuste de inversion 15/03/2025
				this.objTipolente.AltSeg 	= resp.AltSeg 	== 'SI' ? true : false; // Ajuste de inversion 15/03/2025
				this.objTipolente.Dnp 		= resp.Dnp 		== 'SI' ? true : false;
				this.objTipolente.Prisma 	= resp.Prisma 	== 'SI' ? true : false;
				this.objTipolente.Posicion 	= resp.Posicion == 'SI' ? true : false;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objTipolente = {
				IdTipoLente: 0,
				Nombre: '',
				Clave: '',
				Proceso: '',
				Esfera: false,
				Cilindro: false,
				Eje: false,
				Adicion: false,
				AltMon: false,
				AltSeg: false,
				Dnp: false,
				Prisma: false,
				Posicion: false,
				ValMinMon: '',
				ValMaxMon: '',
				ValMinSeg: '',
				ValMaxSeg: '',
				ValDefaultAltSeg: '',
				
            }
            this.errorvalidacion = [];
        },

		cleanSegmento() {
			if(this.objTipolente.AltSeg === false) {
				this.objTipolente.ValMaxSeg = '';
				this.objTipolente.ValMinSeg = '';
			}
			
		},

		cleanMontaje() {
			if(this.objTipolente.AltMon === false) {
				this.objTipolente.ValMaxMon = '';
				this.objTipolente.ValMinMon = '';
			}
			
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objTipolente.IdTipoLente = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
